/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "IeBusiness": {
                "fields": {
                  "category": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "addressToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "vat": {
                    "type": ".squareup.onboarding.business.common.Vat",
                    "id": 8,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": ".squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "businessRegistrationNumber": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "enteredBeneficialOwnerInformation": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "tradingName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.IeBusiness) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in Ireland.
 *
 * SOURCE IeBusiness @ squareup/onboarding/business/ie.proto at 12:1
 */
export const IeBusiness = $root.lookupType('squareup.onboarding.business.IeBusiness');
fixType(IeBusiness);
Builder.createAndAttachToType(IeBusiness);